import { take } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { VersionInfo } from 'src/app/view/help/services/models/versionInfo.data';
import { VersionHistoryService } from 'src/app/view/help/services/version-history-data.service';
@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.scss']
})
export class WhatsNewComponent implements OnInit {
  public lastVersion: VersionInfo | null = null;

  constructor(public dialogRef: MatDialogRef<WhatsNewComponent>, private versionHistoryService: VersionHistoryService) {}

  ngOnInit(): void {
    this.versionHistoryService
      .getLastVersionInfo$()
      .pipe(take(1))
      .subscribe((ver) => (this.lastVersion = ver));
  }
}
